<router-outlet />
@if(appService.loader()) {
    <app-loader />
}
